// One Piece cards, lifted from the standalone want list. There is no One Piece
// price API and no card API, so this list is static and carries no prices - it
// exists to say what you're hunting, not what it's worth.

// DON!! cards sit outside the OPxx-nnn numbering, so no image URL can be built
// for them. They carry this placeholder rather than an empty slot.
export const DON_ART =
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 700'>
       <defs><pattern id='w' width='16' height='16' patternTransform='rotate(45)' patternUnits='userSpaceOnUse'>
         <rect width='16' height='16' fill='#17394F'/><rect width='3' height='16' fill='#1B4560'/>
       </pattern></defs>
       <rect width='500' height='700' fill='url(#w)'/>
       <rect x='24' y='24' width='452' height='652' fill='none' stroke='#C9A227'
             stroke-width='3' stroke-dasharray='11 9' opacity='.65'/>
       <text x='250' y='338' text-anchor='middle' fill='#C9A227' letter-spacing='6'
             font-family='Impact,Anton,sans-serif' font-size='122'>DON!!</text>
       <text x='250' y='398' text-anchor='middle' fill='#8FA3B0' letter-spacing='5'
             font-family='Consolas,monospace' font-size='23'>NO CARD ID</text>
     </svg>`
  );

// Card IDs are upper-case but the print suffix on the CDN is not: the file is
// OP06-118_p2_EN.webp, never OP06-118_P2_EN.webp. Upper-casing the whole id
// 404s every parallel, alt art and reprint.
export function normalizeOpId(code) {
  return String(code || "")
    .trim()
    .toUpperCase()
    .replace(/_([PR])(\d+)/g, (m, letter, n) => "_" + letter.toLowerCase() + n);
}

export function opImageUrl(code) {
  const id = normalizeOpId(code);
  if (!id) return "";
  const set = id.split("-")[0];
  return `https://limitlesstcg.nyc3.cdn.digitaloceanspaces.com/one-piece/${set}/${id}_EN.webp`;
}

const RAW = [
  { set: "OP01", name: "Law", status: "want", note: "Alt art", code: "OP01-002_p1" },
  { set: "OP03", name: "Sogeking", status: "want", note: "Manga alt art", code: "OP03-122_p2" },
  { set: "OP03", name: "DON!! — Sanji thanking Zeff", status: "want", note: "DON!! cards carry no card ID", code: "", don: true },
  { set: "OP03", name: "Luffy", status: "want", note: "Colored wanted poster", code: "ST01-012_p1" },
  { set: "OP04", name: "Law", status: "want", note: "SP", code: "OP01-047_p2" },
  { set: "OP04", name: "Boa Hancock", status: "want", note: "Lisa art", code: "OP01-078_p2" },
  { set: "OP05", name: "Yamato", status: "want", note: "SP", code: "OP01-121_p2" },
  { set: "OP06", name: "Yamato", status: "want", note: "Alt art", code: "OP06-022_p1" },
  { set: "OP06", name: "Zoro", status: "want", note: "Manga alt art", code: "OP06-118_p2" },
  { set: "OP06", name: "DON!! — Mihawk & Zoro", status: "want", note: "Double Pack Set Vol. 3 · no card ID", code: "", don: true },
  { set: "OP06", name: "Robin", status: "want", note: "", code: "OP04-064_p2" },
  { set: "OP07", name: "Vegapunk", status: "want", note: "Leader — alt art", code: "OP07-097_p1" },
  { set: "OP07", name: "Bonney", status: "want", note: "Leader — alt art", code: "OP07-019_p1" },
  { set: "OP07", name: "Boa Hancock", status: "want", note: "Manga", code: "OP07-051_p2" },
  { set: "OP09", name: "Buggy", status: "want", note: "Manga", code: "OP09-051_p2" },
  { set: "OP09", name: "Robin", status: "want", note: "Leader — alt art", code: "OP09-062_p1" },
  { set: "OP09", name: "Buggy", status: "want", note: "Leader — alt art", code: "OP09-042_p1" },
  { set: "OP09", name: "Luffy", status: "want", note: "Leader — alt art", code: "OP09-061_p1" },
  { set: "OP13", name: "Luffy", status: "want", note: "Manga", code: "OP13-118_p2" },
  { set: "OP13", name: "Roger", status: "want", note: "Leader — laughing art", code: "OP13-003_p1" },
  { set: "OP13", name: "Imu", status: "want", note: "Leader — alt art", code: "OP13-079_p1" },
  { set: "OP13", name: "Bonney", status: "want", note: "Leader — crying art", code: "OP13-100_p1" },
  { set: "OP14", name: "Zoro", status: "want", note: "Bubble", code: "PRB02-006_p2" },
  { set: "OP14", name: "Robin", status: "want", note: "SP", code: "OP14-084_p1" },
  { set: "OP15", name: "Zeus", status: "want", note: "SP", code: "OP11-106_p3" },
  { set: "OP15", name: "Luffy", status: "want", note: "Alt art", code: "OP15-119_p1" },
  { set: "OP16", name: "Robin", status: "want", note: "SP", code: "OP14-084_p2" },
  { set: "PRB-01", name: "Yamato", status: "want", note: "Alt art", code: "OP01-121_p4" },
  { set: "PRB-02", name: "Gum-Gum Giant", status: "want", note: "Manga event", code: "OP09-078_p1" },
  { set: "PRB-02", name: "My Era Begins", status: "want", note: "Manga event", code: "OP09-096_p1" },
  { set: "PRB-02", name: "Cross Guild", status: "want", note: "Manga event", code: "OP09-057_p1" },
  { set: "EB-02", name: "Luffy Gear 2", status: "want", note: "Manga", code: "EB02-061_p2" },
];

// Shaped like the cards the rest of the app passes around, so the want list
// component renders these without knowing they came from another game.
export const ONE_PIECE_CARDS = RAW.map((r, i) => ({
  id: `op-${i}`,
  name: r.name,
  number: r.code || "",
  setName: r.set,
  note: r.note,
  status: r.status,
  have: false,
  imageUrl: r.don ? DON_ART : opImageUrl(r.code),
}));